import {GET_AUXILIARY_CLASSIFICATION_DATA,SET_AUXILIARY_CLASSIFICATION_ID,GET_AUXILIARY_MASTER_BY_ACCOUNT_DATA, 
        RESET_AUXILIARY_MASTER_BY_ACCOUNT_DATA,RESET_ACCOUNT_AUXILIARY_DATA,GET_ACCOUNT_AUXILIARY_RESUME_DATA,GET_AUXILIARY_ACCOUNT_RESUME_DATA,RESET_AUXILIARY_ACCOUNT_RESUME_DATA } from '../../../../constants/ActionTypes'

const InitialState={
    AuxiliarClasification:[],
    ClassificationAuxiliaryId:undefined,
    AuxiliaryMasterMovement:[],
    AccountAuxiliaryResume:[],
    AuxiliaryAccountResume:[]
}

function registerAuxiliar(state=InitialState,action){
    switch (action.type) {
        case GET_AUXILIARY_CLASSIFICATION_DATA:
            return {
                ...state,
                AuxiliarClasification:action.payload
            }
        case GET_AUXILIARY_MASTER_BY_ACCOUNT_DATA:

            const IMRAuxiliaryMasterWithList= action.payload.flatMap(x=> [x.imrAuxiliaryMaster,...x.imrAuxiliaryMasters]) 
debugger
            return {
                ...state,
                AuxiliaryMasterMovement:IMRAuxiliaryMasterWithList
            }
        case GET_ACCOUNT_AUXILIARY_RESUME_DATA:

            return {
                ...state,
                AccountAuxiliaryResume: action.payload
            }
        case GET_AUXILIARY_ACCOUNT_RESUME_DATA:

            return {
                ...state,
                AuxiliaryAccountResume: action.payload
            }
        case RESET_AUXILIARY_MASTER_BY_ACCOUNT_DATA:
            return {
                ...state,
                AuxiliaryMasterMovement:[]
            }
        case RESET_ACCOUNT_AUXILIARY_DATA:
            return {
                ...state,
                AccountAuxiliaryResume:[]
            }
        case RESET_AUXILIARY_ACCOUNT_RESUME_DATA:
            return {
                ...state,
                AuxiliaryAccountResume:[]
            }
        case SET_AUXILIARY_CLASSIFICATION_ID:
            return{
                ...state,
                ClassificationAuxiliaryId:action.payload
            }
        default:
            return state;
    }  
}

export default registerAuxiliar;